import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ProcessMediaFix from './process-media-fix-model'
import {
  CreateProcessMediaFixAsync,
  DeleteProcessMediaFixAsync,
  LoadProcessMediaFixsAsync,
} from './processMediaFix-thunk'
const initialState: processMediaFixSliceState = {
  processMediaFix: [],
  selected_processMediaFix: '',
  is_loading_processMediaFix: false,
  is_creating_processMediaFix: false,
  is_deleting_processMediaFix: false,
}
export interface processMediaFixSliceState {
  processMediaFix: ProcessMediaFix[]
  selected_processMediaFix?: string
  is_loading_processMediaFix: boolean
  is_creating_processMediaFix: boolean
  is_deleting_processMediaFix: boolean
}
export const processMediaFixSlice = createSlice({
  name: 'processMediaFix',
  initialState,
  reducers: {
    setSelectedprocessMediaFix: (state, action) => {
      state.selected_processMediaFix = action.payload
    },
    clearStateprocessMediaFix: (state) => {
      state.processMediaFix = []
      state.is_loading_processMediaFix = false
      state.is_creating_processMediaFix = false
      state.is_deleting_processMediaFix = false
    },
    mergeprocessMediaFix: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_processMediaFix = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.processMediaFix = merge(state.processMediaFix, payload) as any
        }
      }
    },

    add_processMediaFix: (state, action) => {
      if (action.payload) {
        state.processMediaFix = [...state.processMediaFix, action.payload]
      }
    },
    set_processMediaFix: (state, action) => {
      let { key, value, id } = action.payload
      state.processMediaFix = state.processMediaFix.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProcessMediaFixsAsync.pending, (state) => {
      state.is_loading_processMediaFix = true
    })
    builder.addCase(LoadProcessMediaFixsAsync.fulfilled, (state, action) => {
      state.is_loading_processMediaFix = false
      if (action.payload) {
        state.processMediaFix = action.payload
      }
    })
    builder.addCase(LoadProcessMediaFixsAsync.rejected, (state) => {
      state.is_loading_processMediaFix = false
    })
    builder.addCase(CreateProcessMediaFixAsync.pending, (state) => {
      state.is_creating_processMediaFix = true
    })
    builder.addCase(CreateProcessMediaFixAsync.fulfilled, (state) => {
      state.is_creating_processMediaFix = false
    })
    builder.addCase(CreateProcessMediaFixAsync.rejected, (state) => {
      state.is_creating_processMediaFix = false
    })
    builder.addCase(DeleteProcessMediaFixAsync.pending, (state) => {
      state.is_deleting_processMediaFix = true
    })
    builder.addCase(DeleteProcessMediaFixAsync.fulfilled, (state, action) => {
      state.is_deleting_processMediaFix = false
      if (state.processMediaFix) {
        state.processMediaFix = state.processMediaFix.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteProcessMediaFixAsync.rejected, (state) => {
      state.is_deleting_processMediaFix = false
    })

    builder.addCase(
      autoThunks.get_media_fixes_for_processed_media.pending,
      (state) => {
        state.is_loading_processMediaFix = true
      },
    )
    builder.addCase(
      autoThunks.get_media_fixes_for_processed_media.fulfilled,
      (state, action) => {
        state.is_loading_processMediaFix = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_media_fixes_for_processed_media.rejected,
      (state) => {
        state.is_loading_processMediaFix = false
      },
    )

    builder.addCase(
      autoThunks.add_media_fix_to_processed_media_state.pending,
      (state) => {
        state.is_loading_processMediaFix = true
      },
    )
    builder.addCase(
      autoThunks.add_media_fix_to_processed_media_state.fulfilled,
      (state, action) => {
        state.is_loading_processMediaFix = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.add_media_fix_to_processed_media_state.rejected,
      (state) => {
        state.is_loading_processMediaFix = false
      },
    )
  },
})

function handleResult(action: any, state: processMediaFixSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_processMediaFix = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.processMediaFix = merge(state.processMediaFix, payload) as any
    }
  }
}

export const {
  clearStateprocessMediaFix,
  setSelectedprocessMediaFix,
  set_processMediaFix,
  mergeprocessMediaFix,
  add_processMediaFix,
} = processMediaFixSlice.actions

export const get_processMediaFix =
  (id?: string) =>
  (state: {
    processMediaFix: {
      processMediaFix: ProcessMediaFix[]
    }
  }): ProcessMediaFix | null => {
    let temp = state?.processMediaFix?.processMediaFix?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.processMediaFix?.processMediaFix[0] || null
  }
export const get_selected_processMediaFix = (state: {
  processMediaFix: processMediaFixSliceState
}): ProcessMediaFix | null => {
  let id = state?.processMediaFix?.selected_processMediaFix
  let temp = state?.processMediaFix?.processMediaFix?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_processMediaFix = (state: {
  processMediaFix: {
    processMediaFix: ProcessMediaFix[]
  }
}): ProcessMediaFix[] => {
  let temp = state?.processMediaFix?.processMediaFix
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_processMediaFix_busy = (state: {
  processMediaFix: processMediaFixSliceState
}) => {
  return (
    state?.processMediaFix.is_deleting_processMediaFix ||
    state?.processMediaFix.is_loading_processMediaFix ||
    state?.processMediaFix.is_creating_processMediaFix
  )
}
export const is_deleting_processMediaFix_busy = (state: {
  processMediaFix: processMediaFixSliceState
}) => {
  return state?.processMediaFix.is_deleting_processMediaFix
}
export const is_loading_processMediaFix_busy = (state: {
  processMediaFix: processMediaFixSliceState
}) => {
  return state?.processMediaFix.is_loading_processMediaFix
}
export const is_creating_processMediaFix_busy = (state: {
  processMediaFix: processMediaFixSliceState
}) => {
  return state?.processMediaFix.is_creating_processMediaFix
}

export default processMediaFixSlice.reducer
